<template>
  <div class="apply-history">
    <el-timeline>
      <el-timeline-item
        v-for="activity in applies"
        :key="activity.id"
        :icon="getFlowIcon(activity.flowStatusItemCode)"
        :color="getFlowStatus(activity.flowStatusItemCode)"
      >
        <el-link
          :underline="false"
          @click="toApplyDetailsPage(activity)"
          class="no-select-text"
          >{{ activity.applyTitle }}</el-link
        >
        <p class="status">
          <flow-status
            :size="9"
            :color="getFlowStatus(activity.flowStatusItemCode)"
          />
          <span>{{ activity.flowStatusItemName }}</span>
        </p>
        <p class="time">{{ getApplyTime(activity.createTime) }}</p>
        <p class="date">{{ getApplyDate(activity.createTime) }}</p>
      </el-timeline-item>

      <el-timeline-item
        class="apply-more"
        icon="el-icon-circle-plus-outline"
        color="#409EFF"
      >
        <el-button type="text" v-show="canLoadNextPage" @click="loadNextPage"
          >查看更多</el-button
        >
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import pagination from "@/view/mixins/pagination";
import FlowStatus from "@/components/FlowStatus/FlowStatus";

import {
  applyForm,
  flowConfig,
  getFlowStatus,
  getFlowIcon,
} from "./apply-config";

export default {
  mixins: [pagination],

  components: {
    FlowStatus,
  },

  created() {
    this.setApplyHistoryList();
  },

  computed: {
    applies() {
      return this.applyHistoryList;
    },
  },
  data() {
    return {
      applyHistoryList: [],
      setTableData: this.setApplyHistoryList,

      getFlowStatus: getFlowStatus,
      getFlowIcon: getFlowIcon,
    };
  },
  methods: {
    setApplyHistoryList() {
      const params = Object.assign(this.$js.deepClone(this.pagePagination), {
        params: {
          businessId: this.$route.params.businessId,
        },
      });
      this.$api.getApplyHistory(params).then((res) => {
        this.applyHistoryList.push(...res.records);
        this.total = res.total;
        this.pages = res.pages;
      });
    },

    getApplyTime(time) {
      return this.$js.dateTimeUtils(new Date(time)).HHmm;
    },

    getApplyDate(time) {
      return this.$js.dateTimeUtils(new Date(time)).date;
    },

    toApplyDetailsPage() {},
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

.apply-history {
  min-height: calc(100vh - #{$topMenuHeight} - 30px);
  margin: 15px;
  background: #fff;
  padding: 15px;
  padding-top: 50px;
}

.el-timeline {
  font-size: 14px;
  padding-left: 250px;

  .el-timeline-item {
    padding-bottom: 60px;

    ::v-deep .el-timeline-item__tail {
      // 连接线颜色
      // border-color: #8bc34a;
    }

    ::v-deep .el-timeline-item__node {
      width: 20px;
      height: 20px;
      left: -5px;

      .el-timeline-item__icon {
        font-size: 18px;
        font-weight: 500;
      }
    }

    ::v-deep .el-timeline-item__wrapper {
      padding-left: 60px;

      .el-timeline-item__content {
        // title
        .el-link {
          font-size: 16px;
          font-weight: 400;
        }

        .time,
        .date {
          position: absolute;
          left: -100px;
          top: 0;
          color: #c3c3c3;
          text-align: right;
          width: 80px;
        }

        .time {
          font-size: 18px;
        }

        .date {
          top: 25px;
        }

        .status {
          margin-top: 10px;
          font-size: 14px;
          color: #737373;

          span {
            margin-left: 12px;
          }
        }
      }
    }
  }
}

.apply-more {
  ::v-deep .el-timeline-item__wrapper {
    top: -10px;
  }
}
</style>
